export const providers = {
  bizandgo: 'bizandgo',
  vodafone: 'vodafone',
  redsys: 'redsys'
}

export type providers = string

const subdomain = document.location.hostname.split('.').shift() || ''

export const provider: providers = providers[subdomain] || 'bizandgo'



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/Providers.ts